import { JsonObject, JsonProperty } from 'json2typescript';

import { DateConverter } from '@shared/utils';

@JsonObject('deceasedInformations')
export class DeceasedInformation {
  @JsonProperty('address', String, true)
  public address = '';

  @JsonProperty('birthname', String, true)
  public birthname = '';

  @JsonProperty('city', String, true)
  public city = '';

  @JsonProperty('departmentOfBirth', String, true)
  public departmentOfBirth = '';

  @JsonProperty('communeOfBirth', String, true)
  public communeOfBirth = '';

  @JsonProperty('complementaryAddress', String, true)
  public complementaryAddress = '';

  @JsonProperty('countryOfBirth', String, true)
  public countryOfBirth = '';

  @JsonProperty('country', String, true)
  public country = '';

  @JsonProperty('dateOfBirth', DateConverter, true)
  public dateOfBirth: Date | undefined = undefined;

  @JsonProperty('firstname', String, true)
  public firstname = '';

  @JsonProperty('gender', String, true)
  public gender = '';

  @JsonProperty('maritalStatus', String, true)
  public maritalStatus = '';

  @JsonProperty('name', String, true)
  public name = '';

  @JsonProperty('zipcode', String, true)
  public zipcode = '';

  @JsonProperty('iban', String, true)
  public iban = '';

  public fullName? = '';
}
